import { createContext, useContext } from 'react';

export interface ArtistThemeVariant {
  id: string;
  label: string;
  swatch: string;
  accent: string;
  style: Record<string, string>;
}

interface ArtistThemeContextValue {
  variants: ArtistThemeVariant[];
  selectedThemeId: string;
  setSelectedThemeId: (themeId: string) => void;
}

export const ArtistThemeContext = createContext<ArtistThemeContextValue>({
  variants: [],
  selectedThemeId: 'primary',
  setSelectedThemeId: () => undefined,
});

export const useArtistTheme = () => useContext(ArtistThemeContext);
